import * as Switch from '@radix-ui/react-switch';
import { Book, HalfMoon, SunLight } from 'iconoir-react';
import { useContext } from 'react';
import { ThemeContext } from '../contexts/ThemeContext';


export default function Nav() {
  const { theme, setTheme } = useContext(ThemeContext);

  const changeTheme = () => {
    setTheme(theme === 'light' ? 'dark' : 'light');
  };

	return (
		<div className={`z-50`}>
			<nav className="flex justify-between items-center">
				<Book height={36} width={36} className="stroke-1 text-gray-500 dark:text-white" />
				<div className="flex space-x-2 divide-x-2">
					<div className="pl-2 flex space-x-3 items-center">
						<Switch.Root
							className="w-[42px] h-[20px] bg-blackA6 rounded-full relative bg-dark-500 data-[state=checked]:bg-brand-purple outline-none cursor-pointer"
              checked={theme === 'dark'}
              onCheckedChange={changeTheme}
						>
							<Switch.Thumb className="block w-[16px] h-[16px] bg-white rounded-full transition-transform duration-100 translate-x-0.5 will-change-transform data-[state=checked]:translate-x-[24px]" />
						</Switch.Root>
						{theme === 'light' && <SunLight height={20} width={20} className='stroke-1 text-gray-500 dark:text-white' />}
						{theme === 'dark' && <HalfMoon
							height={20}
							width={20}
							className="stroke-1 text-gray-500 dark:text-white"
						/>}
					</div>
				</div>
			</nav>
		</div>
	);
}
